class DataPermissionManager {
    // _dataModule = null;
    _permissions = null;
    _map = null;

    static _inst = null;
    static getInstance() {
        if (!DataPermissionManager._inst) DataPermissionManager._inst = new DataPermissionManager();
        return DataPermissionManager._inst;
    }

    static updatePermissions(permissions) {
        return DataPermissionManager.getInstance().updatePermissions(permissions);
    }

    static checkDataPermission(entity, data, permissionField) {
        return DataPermissionManager.getInstance().checkDataPermission(entity, data, permissionField);
    }
    static filterDatas(entity, data, permissionField) {
        return DataPermissionManager.getInstance().filterDatas(entity, data, permissionField);
    }

    constructor(/*dataModule*/) {
        // this._dataModule = dataModule;
    }

    updatePermissions(permissions) {
        this._permissions = permissions;
        this._map = {};
        for (const permission of permissions) {
            const scope = this._map[permission.entity] || (this._map[permission.entity] = {});
            scope[permission.bizTypeCode] = {readonly:permission.readOnly == '1'};
        }
    }

    getBusinessFeatures(data, permissionField) {
        if (!data) return true;
        if (!permissionField) permissionField = 'bizTypeCode';
        return data[permissionField];
    }

    checkDataPermission(entity, data, permissionField) {
        if (!this._map) return true;
        const features = this.getBusinessFeatures(data, permissionField);
        if (features == null) return true;
        let option = this._map[entity];
        if (option) option = option[features];
        if (!option) return true;
        return !option.readonly
    }
    filterDatas(entity, datas, permissionField) {
        if (!datas) return [];
        if (!(datas instanceof Array)) datas = [datas];
        const res = [];
        for (const data of datas) {
            if (this.checkDataPermission(entity, data, permissionField)) res.push(data);
        }
        return res;
    }
}

export default DataPermissionManager;